import React from "react";
import { Button } from "../ui/Button";
import { CheckSquare, FileStack, Plus, UserPlus, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LeadHeader = ({
  openBulkModal,
  selectMode,
  setSelectMode,
  selectedCount,
  onBulkAssign,
  onSelectAll,
  onClearSelection,
  isAdmin,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
          My Leads
        </h1>
        {selectMode ? (
          <p className="text-sm text-[#00a8b4] mt-1 font-medium">
            {selectedCount} selected
          </p>
        ) : (
          <p className="text-sm text-slate-600 mt-1">
            Manage and track your leads
          </p>
        )}
      </div>
      <div className="flex items-center gap-2">
        {selectMode ? (
          <>
            <Button
              size="sm"
              variant="outline"
              className="h-8 text-xs rounded-full gap-1"
              onClick={onSelectAll}
            >
              <CheckSquare size={14} />
              All
            </Button>
            <Button
              size="sm"
              className="h-8 text-xs rounded-full bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white gap-1"
              onClick={onBulkAssign}
              disabled={selectedCount === 0}
            >
              <UserPlus size={14} />
              Assign ({selectedCount})
            </Button>
            <Button
              size="icon"
              variant="ghost"
              className="h-8 w-8 rounded-full"
              onClick={() => {
                onClearSelection();
                setSelectMode(false);
              }}
            >
              <X size={18} />
            </Button>
          </>
        ) : (
          <>
            {isAdmin && (
              <Button
                size="icon"
                variant="outline"
                className="rounded-full"
                onClick={() => setSelectMode(true)}
                title="Select leads to assign"
              >
                <UserPlus className="w-5 h-5 text-slate-600" />
              </Button>
            )}
            <Button
              size="icon"
              className="rounded-full bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white"
              onClick={openBulkModal}
              title="Bulk upload leads"
            >
              <FileStack className="w-5 h-5" />
            </Button>
            <Button
              size="icon"
              className="rounded-full bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white"
              onClick={() => navigate("/add-lead")}
              title="Add new lead"
            >
              <Plus className="w-5 h-5" />
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default LeadHeader;
